import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import { Category, Product, Station } from "../models/product/ProductModel";

export class ProductApi extends BaseApi {
  private static instance: ProductApi;

  public static get(): ProductApi {
    if (!this.instance) {
      this.instance = new ProductApi();
    }
    return this.instance;
  }

  public getAllProducts = BaseApi.createEndpoint<Product[], null>(
    HttpMethodEnum.GET,
    "/product/all"
  );

  public updateOrCreateProduct = BaseApi.createEndpoint<null, Product>(
    HttpMethodEnum.POST,
    "/product/update"
  );

  public deleteProduct = BaseApi.createEndpoint<null, Product>(
    HttpMethodEnum.DELETE,
    "/product/update"
  );

  public getAllCategories = BaseApi.createEndpoint<Category[], null>(
    HttpMethodEnum.GET,
    "/product/category/all"
  );

  public updateOrCreateCategory = BaseApi.createEndpoint<null, Category>(
    HttpMethodEnum.POST,
    "/product/category/update"
  );

  public deleteCategory = BaseApi.createEndpoint<null, Category>(
    HttpMethodEnum.DELETE,
    "/product/category/update"
  );

  public getAllStations = BaseApi.createEndpoint<Station[], null>(
    HttpMethodEnum.GET,
    "/product/station/all"
  );

  public updateOrCreateStation = BaseApi.createEndpoint<null, Station>(
    HttpMethodEnum.POST,
    "/product/station/update"
  );

  public deleteStation = BaseApi.createEndpoint<null, Station>(
    HttpMethodEnum.DELETE,
    "/product/station/update"
  );
}

export const productApi = ProductApi.get();
